import { render, staticRenderFns } from "./Tagger.vue?vue&type=template&id=0e818895&scoped=true"
import script from "./Tagger.vue?vue&type=script&lang=js"
export * from "./Tagger.vue?vue&type=script&lang=js"
import style0 from "./Tagger.vue?vue&type=style&index=0&id=0e818895&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e818895",
  null
  
)

export default component.exports